import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const TypographyStyled = styled(Typography)<{ highlight?: string }>`
  font-weight: ${({ highlight }) => (highlight === 'true' ? 700 : 'inherit')};
`;
